// @ts-ignore
import { referrer, currentPage } from '../state.ts'
import axios from "axios";
import { watch } from 'vue'

const celium = axios.create();
celium.defaults.baseURL = process.env.VUE_APP_CELIUM_BASE_URL;

export default function doesCoverageCheck(geocodeResult, loading, coverageCheckResult, error) {
    watch(geocodeResult, (newValue) => {
        loading.value = true
        error.value = false

        const payload = {
            longitude: newValue.value.geometry.coordinates[0],
            latitude: newValue.value.geometry.coordinates[1],
            with_geojson: false,
            with_planned: true,
            source: 'customer',
            address: newValue.value.place_name
        };

        if (referrer.value) {
            payload['referrer'] = referrer.value
        }

        if (currentPage.value) {
            payload['current_page'] = currentPage.value
        }

        celium.post('prequalification/gis', payload).then((result) => {
            coverageCheckResult.value = result.data
        }).catch(() => {
            error.value = true
        }).finally(() => {
            loading.value = false
        })
    })
}
